import React from 'react';
import { motion } from 'framer-motion';

export default function SupportCTA() {
  return (
    <section className="max-w-5xl mx-auto px-4 py-24 text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-navy-nav/20 backdrop-blur-3xl rounded-[2rem] md:rounded-[3rem] p-10 md:p-20 relative overflow-hidden group border border-white/5"
      >
        {/* Background Gradients - Softened */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-b from-brand-pink/5 to-transparent pointer-events-none opacity-30"></div>
        <div className="absolute -top-32 -right-32 w-80 h-80 bg-glow-purple/5 rounded-full blur-[100px] pointer-events-none"></div>
        <div className="absolute -bottom-32 -left-32 w-80 h-80 bg-glow-cyan/5 rounded-full blur-[100px] pointer-events-none"></div>

        <h2 className="text-3xl md:text-5xl font-bold text-white/90 mb-6 relative z-10 tracking-tight">
          Still Have Questions?
        </h2>
        
        <p className="text-text-body text-lg md:text-xl mb-12 max-w-2xl mx-auto relative z-10 leading-relaxed">
          Our team of AI trading experts is on standby to help you activate your account and fine-tune your strategy.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 relative z-10">
          <a 
            href="https://profitlense.ai/contact-us/" 
            className="w-full sm:w-auto bg-brand-primary hover:bg-brand-primary/90 text-white font-bold py-4 px-12 rounded-2xl transition-all shadow-xl shadow-brand-primary/10 flex items-center justify-center gap-2"
          >
            Contact Support
          </a>
          <a 
            href="https://profitlense.ai/our-interactive-guides/" 
            className="w-full sm:w-auto bg-white/5 hover:bg-white/10 text-white/80 font-bold py-4 px-12 rounded-2xl transition-all border border-white/10 hover:border-brand-secondary/30 flex items-center justify-center gap-2"
          >
            View More Guides
          </a>
        </div>
      </motion.div>
    </section>
  );
}